import type { BetterFeaturePluginSchema } from "@di-devs/better-feature/types";
import { z } from "zod";

// Base response schema
export const responseSchema = z.object({
	message: z.coerce.string(),
	success: z.coerce
		.string()
		.transform((val) => val === "true" || val === "1")
		.refine((val) => typeof val === "boolean", {
			message:
				"Query param must be 'true' or '1', otherwise it will default to false",
		}),
});

// Authenticated user schema (domain model)
export const authenticatedUserSchema = z.object({
	managerId: z.number(),
	username: z.string(),
	authLevel: z.number(),
});

// Better Feature plugin schema for database integration
export const authBetterFeatureSchema = {
	manager: {
		fields: {
			managerId: { type: "number", required: false, unique: true },
			username: { type: "string", required: true, unique: true },
			pwhash: { type: "string", required: true },
			recoveryMail: { type: "string", required: false },
			authLevel: { type: "number", required: true },
			isActivated: { type: "boolean", required: false },
		},
	},
} satisfies BetterFeaturePluginSchema;
